import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { GridOverlay } from '@mui/x-data-grid';
import React from 'react';

import { LoadingStage } from 'components/Loader';

declare module '@mui/x-data-grid' {
  interface LoadingOverlayPropsOverrides {
    stage?: LoadingStage;
  }
}

export const DataGridLoadingOverlay: React.FC<{ stage: LoadingStage }> = ({ stage }) => {
  const skeletonRowWidths = ['100%', '92%', '96%', '88%', '94%', '90%'];

  return (
    <GridOverlay
      sx={{
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        height: '100%',
        px: 2,
        py: 1.5,
      }}
    >
      <Stack spacing={1.25} sx={{ width: '100%', maxWidth: '100%' }}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', px: 1, pt: 0.5 }}
        >
          {stage}
        </Typography>

        {skeletonRowWidths.map((width, index) => (
          <Box
            key={`data-grid-loading-row-${index}`}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              px: 1,
              py: 0.75,
              borderRadius: 1,
              backgroundColor: 'background.paper',
              border: '1px solid',
              borderColor: 'divider',
            }}
          >
            <Skeleton variant="rounded" animation="wave" width={18} height={18} sx={{ flex: '0 0 auto' }} />
            <Skeleton variant="rounded" animation="wave" width={width} height={20} sx={{ borderRadius: 1 }} />
          </Box>
        ))}
      </Stack>
    </GridOverlay>
  );
};
